import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

const partOfDay = (hour) =>
  hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";

// Top-bar greeting (left side): "Good evening, Alice" + today's date. Hidden on phones, where the
// top bar only has the menu button and the actions. Names the API sends as "undefined" are ignored.
export default function GrGreeting({ name, now = new Date(), sx }) {
  const first = String(name || "").trim();
  const showName =
    first &&
    first.toLowerCase() !== "undefined" &&
    first.toLowerCase() !== "null";
  const date = now.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  return (
    <Box
      sx={{
        minWidth: 0,
        display: { xs: "none", md: "block" },
        fontFamily: gr.font.family,
        ...sx,
      }}
    >
      <Box
        component="p"
        sx={{
          m: 0,
          fontSize: gr.font.size.lg,
          fontWeight: gr.font.weight.semibold,
          color: gr.color.ink,
          lineHeight: 1.3,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {partOfDay(now.getHours())}
        {showName ? `, ${first}` : ""}
      </Box>
      <Box
        component="p"
        sx={{
          m: 0,
          fontSize: gr.font.size.sm,
          color: gr.color.muted,
          lineHeight: 1.4,
        }}
      >
        {date}
      </Box>
    </Box>
  );
}

GrGreeting.propTypes = {
  name: PropTypes.string,
  now: PropTypes.instanceOf(Date),
  sx: PropTypes.object,
};
